module.exports = __webpack_public_path__ + "img/rankingThree.6075edb3.png";